module.exports = __webpack_public_path__ + "static/media/sip_resumed_illustration_myway.2b8ab71e.svg";